<template>
  <div :id="`stickers-${uuid}`" class="w-stickers" @click="emitClick">
    <div class="content">
      <div v-if="!alwaysEnabled" class="close" @click.stop="emitClose">
        <div class="content">
          <img class="f-w" src="/images/close.png" alt="">
        </div>
      </div>
      <div class="sticker-col left-side">
        <div class="f-w">
          <div class="sticker">
            <div :data-col-index="0" class="colored-sticker yellow" />
          </div>
          <div class="sticker">
            <div :data-col-index="1" class="colored-sticker fuschia" />
          </div>
        </div>
      </div>
      <div class="sticker-col middle">
        <div class="f-w">
          <div class="sticker top">
            <div :data-col-index="2" class="colored-sticker red" />
          </div>
          <div class="sticker bottom">
            <div :data-col-index="3" class="colored-sticker orange" />
          </div>
        </div>
      </div>
      <div class="sticker-col">
        <div class="f-w">
          <div class="sticker">
            <div :data-col-index="4" class="colored-sticker green" />
          </div>
          <div class="sticker">
            <div :data-col-index="5" class="colored-sticker blue" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Stickers box to pick stickers from. Initial behaviour :
 * Click on the box to widen, then drag sticker from the box to place them on a droppable
 *
 * @vue-prop {Boolean} alwaysEnabled - If true, stickers will always be draggable
 * @vue-prop {String|HTMLElement} container - jQuery draggable containent option
 */

import $ from 'jquery';

export default {
  name: 'Stickers',
  props: {
    alwaysEnabled: Boolean,
    container: {
      type: [String, HTMLElement],
      default: null,
    },
  },
  data() {
    return {
      dragCreated: false,
    };
  },
  mounted() {
    if (this.alwaysEnabled) {
      this.enableDrag(this.container);
    }
  },
  methods: {
    enableDrag(selector) {
      this.dragCreated = true;
      $($(this.$el).find('.sticker .colored-sticker')).draggable({
        helper: 'clone',
        containment: selector,
        addClasses: false,
        revert: 'invalid',
        refreshPositions: true,
        start(e, ui) {
          $(ui.helper).css('width', `${ui.helper.prevObject[0].offsetWidth}px`);
          $(ui.helper).css('height', `${ui.helper.prevObject[0].offsetHeight}px`);
        },
      });
      setTimeout(() => {
        $($(this.$el).find('.sticker .colored-sticker')).draggable('enable');
      }, 1);
    },
    disableDrag() {
      if (this.dragCreated) {
        $($(this.$el).find('.sticker .colored-sticker')).draggable('disable');
      } else {
        this.$emit('click');
      }
    },
    emitClick() {
      if (!this.alwaysEnabled) {
        this.$emit('click');
      }
    },
    emitClose() {
      if (!this.alwaysEnabled) {
        this.$emit('closeClick');
      }
    },
  },
};
</script>

<style>
.w-stickers {
  width: 25%;
  padding-top: 25%;
  position: relative;
}
.w-stickers .content {
  position: absolute;
  top: 0px;bottom: 0px;left: 0px;right: 0px;
  background: #f1f1f1;
  border-radius: 50%;
  box-shadow: 0px 0px 5px #bbb;
}
.w-stickers .content .close {
  width: 25%;
  padding-top: 25%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10005;
}
.w-stickers .content .close .content {
  background: white;
  border-radius: 50%;
  padding: 25%;
  box-sizing: border-box;
}
.w-stickers .content .close .content img { display: block; }
.sticker-col {
  width: 23%;
  margin: 0px 2.5%;
  display: inline-flex;
  align-items: center;
  height: 100%;
  vertical-align: top;
}
.sticker-col.left-side { margin-left: 10.5%; }
.sticker-col .sticker {
  width: 100%;
  padding-top: 110%;
  position: relative;
}
.sticker-col .sticker .colored-sticker {
  margin: 5% 0px;
  position: absolute;
  top: 0px;bottom: 0px;left: 0px;right: 0px;
}
.colored-sticker.ui-draggable-dragging {
  opacity: 0.6;
  cursor: grabbing;
}
.sticker-col.middle {
  position: relative;
}
.sticker-col.middle .sticker {
  position: absolute;
  left: 0px; right: 0px;
}
.sticker-col.middle .sticker.top { top: 2.5%; }
.sticker-col.middle .sticker.bottom { bottom: 2.5%; }
.colored-sticker {
  box-shadow: 0px 3px 5px #bbb;
  transition: transform 0.2s ease-in-out, opacity 0.2s ease-in-out;
  cursor: grab;
  white-space: normal;
  z-index: 10002;
}
.colored-sticker.blue { background: #00adee; }
.colored-sticker.green { background: #56d36d; }
.colored-sticker.fuschia { background: #f462ff; }
.colored-sticker.yellow { background: #d6de23; }
.colored-sticker.red { background: #f15c61; }
.colored-sticker.orange { background: #f6921e; }
</style>
